export default __webpack_public_path__ + "static/media/soek-icon.892c1ad6.svg";